export default __webpack_public_path__ + "static/avatar-johnny-5037a9d3614765f2272fc23a21769c45.png";